/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewer_Deep_P1Inputs */

const en_viewer_deep_p1 = /** @type {(inputs: Viewer_Deep_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every node is labelled with one of six types: string, number, boolean, null, object, or array. That last distinction is the one raw text handles worst, because arrays and objects are both bracketed and a quick glance at a deeply indented document does not reliably tell you which you are looking at. It matters when you are writing an accessor, since one needs an index and the other needs a key.`)
};

const ko_viewer_deep_p1 = /** @type {(inputs: Viewer_Deep_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`모든 노드에는 여섯 가지 타입 중 하나가 표시됩니다. 문자열, 숫자, 불리언, null, 객체, 배열입니다. 마지막 구분이 원문 텍스트가 가장 못하는 부분입니다. 배열과 객체는 둘 다 괄호로 묶이고, 깊게 들여쓴 문서를 얼핏 봐서는 무엇을 보고 있는지 확실히 알 수 없습니다. 접근자를 쓸 때는 이것이 중요합니다. 한쪽은 인덱스가, 다른 쪽은 키가 필요하기 때문입니다.`)
};

const ja_viewer_deep_p1 = /** @type {(inputs: Viewer_Deep_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべてのノードには 6 つの型のいずれかが表示されます。文字列、数値、真偽値、null、オブジェクト、配列です。最後の区別が生のテキストの最も苦手なところです。配列とオブジェクトはどちらもかっこで囲まれ、深くインデントされた文書をちらりと見ただけではどちらを見ているのか確実には分かりません。アクセサを書くときにこれが重要になります。一方は添字を、他方はキーを必要とするからです。`)
};

/**
* | output |
* | --- |
* | "Every node is labelled with one of six types: string, number, boolean, null, object, or array. That last distinction is the one raw text handles worst, becau..." |
*
* @param {Viewer_Deep_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const viewer_deep_p1 = /** @type {((inputs?: Viewer_Deep_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewer_Deep_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewer_deep_p1(inputs)
	if (locale === "ko") return ko_viewer_deep_p1(inputs)
	return ja_viewer_deep_p1(inputs)
});